import React, { useContext } from 'react';

import { Link } from '@material-ui/core';
import { Divider } from '@mui/material';
import { Context as AuthContext } from '../../../contexts/authContext';
import RegisterFormBusiness from './RegisterFormBusiness';
import { MDBox } from '../../MDBox';
import { MDTypography } from '../../MDTypography';
import { MDButton } from '../../MDButton';
import { IllustrationLayout } from 'components/layout/IllustrationLayout';
import bgImage from '../../../assets/images/illustrations/illustration-reset.jpg';

export default function RegisterForm() {
  const { errors, signInWithMicrosoft, isLoading } = useContext(AuthContext);
  
  const handleMicrosoftLogin = () => {
    if (signInWithMicrosoft) {
      signInWithMicrosoft();
    }
  };

  return (
    <IllustrationLayout
      title="Register"
      description="Enter carrier info to register"
      illustration={bgImage}
    >
      <MDBox component="form" role="form" style={{ paddingTop: 0 }}>
        {errors && errors.serverError && (
          <MDTypography color="error">{errors.serverError}</MDTypography>
        )}
        <RegisterFormBusiness />
        
        <MDBox mt={3} mb={2} textAlign="center">
          <Divider>
            <MDTypography variant="button" color="text" fontWeight="regular">
              or
            </MDTypography>
          </Divider>
        </MDBox>
        
        <MDBox mb={1}>
          <MDButton
            variant="outlined"
            color="dark"
            size="large"
            fullWidth
            onClick={handleMicrosoftLogin}
            disabled={isLoading}
            sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              border: '1px solid #ddd',
              '&:hover': {
                backgroundColor: '#f5f5f5'
              }
            }}
          >
            <MDBox display="flex" alignItems="center">
              <MDBox 
                component="img" 
                src="https://teracards.blob.core.windows.net/tm-public-assets/microsoft_logo_512px.png"
                alt="Microsoft Logo"
                width="16px"
                mr={1}
              />
              Sign up with Microsoft
            </MDBox>
          </MDButton>
        </MDBox>
        <MDBox mt={4} mb={1} display="flex" justifyContent="space-between">
          <MDBox sx={{ maxwidth: '50%' }}>
            <Link href="/forgot-password" variant="body2">
              <MDTypography color="text" component="span" variant="caption">
                Forgot password?
              </MDTypography>
            </Link>
          </MDBox>
          <MDBox>
            <Link href="/login" variant="body2">
              <MDTypography color="text" component="span" variant="caption">
                Already have an account? Log in here
              </MDTypography>
            </Link>
          </MDBox>
        </MDBox>
      </MDBox>
    </IllustrationLayout>
  );
}
